import storiesService from '@/views/Stories/StoriesService';

export default {
  applyFilters({ commit }, filters) {
    commit('applyFilters', filters);
  },

  async getStories({ commit, state }, { append = true }) {
    if (state.fetching) return;
    commit('setFetching', { val: true });

    const { items: items_, total } = await storiesService.getStories(state.filters);
    let items = [];
    if ((state.filters.page > 1) && append) {
      items = items.concat(state.items);
    }
    items = items.concat(items_);

    commit('setItems', { items, total });
    commit('setFetching', { val: false });
  },

  reset({ commit }) {
    commit('reset');
  }
};
